import React from 'react'
import { css } from '@emotion/react'
import { array } from 'prop-types'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

import Column from './Column'

const livechatWebsiteUrl = process.env.GATSBY_LIVECHAT_WEBSITE_URL

const linksContainerCss = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-flow: row wrap;
  gap: 2rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    > div {
      margin-bottom: 0.5rem;
      font-size: 1.25rem;
      line-height: 1.4;
      font-weight: 500;
    }

    a {
      font-size: 1rem;
      line-height: 1;
      font-weight: 400;

      &:hover {
        color: inherit;
        text-decoration: underline;
      }
    }
  }

  ${mediaQueries.mediumScreen()} {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8rem;
  }
`

const linksList = [
  {
    label: 'Build',
    list: [
      { label: 'Universe', route: '/universe' },
      { label: 'Platform', link: 'https://platform.text.com/' },
    ],
  },
  {
    label: 'Distribute',
    list: [
      { label: 'Marketplace', internalRoute: '/' },
      {
        label: 'Developer Program',
        link: 'https://platform.text.com/developer-program',
      },
      { label: 'Incubator', link: 'https://incubator.text.com/' },
      { label: 'Partner Program', link: 'https://partners.livechat.com/' },
    ],
  },
  {
    label: 'Company',
    list: [
      { label: 'Vision', route: '/vision' },
      { label: 'Focus', route: '/focus' },
      { label: 'Careers', route: '/careers' },
      { label: 'Team', route: '/team' },
      { label: 'Press', route: '/press' },
    ],
  },
  {
    label: 'Legal',
    list: [
      {
        label: 'Marketplace Terms',
        link: `${livechatWebsiteUrl}/legal/terms/`,
      },
      {
        label: 'Terms of Use',
        link: `${livechatWebsiteUrl}/legal/terms-of-use/`,
      },
      {
        label: 'Privacy Policy',
        link: `${livechatWebsiteUrl}/legal/privacy-policy/`,
      },
      { label: 'Security', link: `${livechatWebsiteUrl}/legal/security/` },
      {
        label: 'GDPR',
        link: `${livechatWebsiteUrl}/legal/for-clients/#privacy-faq`,
      },
    ],
  },
]

const Links = () => {
  return (
    <div css={linksContainerCss}>
      {linksList?.map(({ label, list }) => (
        <Column key={label} label={label} list={list} />
      ))}
    </div>
  )
}

Links.propTypes = {
  links: array,
}

export default Links
